<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="68%"
    height="40%"
    [title]="popupTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onClosePopup()"
>
    <div *dxTemplate="let item of 'content'" class="form-editor-content">
        <dx-box height="100%" width="100%" direction="col" class="application-editor-box">
            <dxi-item [ratio]="1">
                <dx-form #formEditor [colCount]="3" width="100%" height="100%" [labelLocation]="defaultLabelLocation">
                    <dxi-item isRequired="true">
                        <dxo-label text="Due Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [(value)]="lineItem.dueDate"
                                (onValueChanged)="onDueDateValueChange()"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Allowance Category"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [dataSource]="editorData.allowanceCategory"
                                [(value)]="lineItem.allowanceCategoryId"
                                (onValueChanged)="onAllowanceCategoryChanged()"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Deposit Type"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [dataSource]="editorData.depositType"
                                [(value)]="lineItem.depositTypeId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Category"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [dataSource]="editorData.category"
                                [(value)]="lineItem.categoryId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Allowance Sub-Category"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="allowanceSubCategoryName"
                                valueExpr="allowanceSubCategoryId"
                                [searchEnabled]="true"
                                [dataSource]="allowanceSubCategory"
                                [(value)]="lineItem.allowanceSubCategoryId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Deposit Status"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [dataSource]="editorData.depositStatus"
                                [(value)]="lineItem.depositStatusId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area [(value)]="lineItem.description"></dx-text-area>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Allowance Start Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [openOnFieldClick]="true"
                                [(value)]="lineItem.allowanceStartDate"
                                (onValueChanged)="onStartDateChanged()"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Deposit Ref #"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="lineItem.depositRef"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Status"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [dataSource]="editorData.statusResult"
                                [(value)]="lineItem.statusId"
                                (onValueChanged)="onStatusChanged()"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Allowance End Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [min]="lineItem.allowanceStartDate"
                                [openOnFieldClick]="true"
                                [(value)]="lineItem.allowanceEndDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Deposit Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box [format]="currencyFormat" [(value)]="lineItem.depositAmount"></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Response to Owner"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="lineItem.responseToOwner"></dx-text-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%" class="form-editor-toolbar">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                hint="Cancel"
                                [icon]="iconClose"
                                (onClick)="onClosePopup()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Ok"
                                hint="Ok"
                                [icon]="iconCheck"
                                (onClick)="onOkClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
